export default "__VITE_ASSET__aeedec8d__"